import { get, post, put, del } from './api';

export const getBranches = (params) => get('/branches.php', params);

export const getBranchById = (id) => get(`/branches.php?id=${id}`);

export const createBranch = (data) => post('/branches.php', data);

export const updateBranch = (data) => put('/branches.php', data);

export const deleteBranch = (id) => del(`/branches.php?id=${id}`);
